import { connect } from 'react-redux'
import UI from './UI'
import { push } from 'connected-react-router'
import { cleanFreeCoursesTagsAction, selectCategory } from '../store'
import { decorateUrl } from 'components/common/UTMscript'
import { ProfileTypes } from 'constants/'

const mapStateToProps = ({ catalog, user, referential }) => ({
  categories: catalog.categories,
  selectedCategory: catalog.selectedCategory,
  allCoursesCategory: catalog.allCoursesCategory,
  loading: catalog.loadingCategories,
  profileType: user?.ProfileType ? ProfileTypes[referential?.ProfileTypes[user.ProfileType]] : null
})

const mapDispatchToProps = (dispatch) => ({
  handleCategoryClick: (category, initialCourses) => dispatch(selectCategory(category, initialCourses)),
  cleanFreeCoursesTags: () => dispatch(cleanFreeCoursesTagsAction({})),
  goToCatalog: url => dispatch(push(decorateUrl(url)))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
